export default {
	computed: {
		mockInterviewsEnabled() {
			return process.env.MOCK_INTERVIEWS_ENABLED === 'true';
		},
	},
};
